import { combineReducers } from 'redux';
import interviewListsReducer, { InterviewListsState } from './interviewLists';
import menteeListsReducer, { MenteeListsState } from './menteeLists';

export type MentorStoreState = {
  menteeLists: MenteeListsState;
  interviewLists: InterviewListsState;
};

const mentorReducer = combineReducers({
  menteeLists: menteeListsReducer,
  interviewLists: interviewListsReducer,
});

export default mentorReducer;
